import { ComponentPropsWithoutRef } from 'react';
import finfit from '../assets/img/partners/finfit.jpg';
import FinFit from '../assets/img/partners/finfit.tsx';
import konnectMd from '../assets/img/partners/konnect-md.png';
import stretchDollar from '../assets/img/partners/stretch_dollar.jpg';

export const partnersMap = new Map<string, string>([
  ['stretchdollar', 'stretchdollar'],
  ['finfit', 'finfit'],
  ['KonnectMD', 'KonnectMD'],
]);

export const partnerLogoMap = new Map<string, string>([
  ['stretchdollar', stretchDollar],
  ['finfit', finfit],
  ['KonnectMD', konnectMd],
]);

export const partnerSvgLogoMap = new Map<
  string,
  (props: ComponentPropsWithoutRef<'svg'>) => JSX.Element
>([['finfit', FinFit]]);

export const hasValidPartnership = (partnership: string) => partnersMap.has(partnership);

export const isFinFitPartnership = (partnership: string) => partnership === 'finfit';

export const normalizePartnership = (raw: unknown): string => {
  if (typeof raw !== 'string' || !raw) return '';
  const lower = raw.toLowerCase();
  for (const key of partnersMap.keys()) {
    if (key.toLowerCase() === lower) return key;
  }
  return '';
};
